<script setup lang="ts">
import { NCard, NAlert, NText } from 'naive-ui'
import type { ConfigSection } from '../../api'

defineProps<{ section: ConfigSection }>()
</script>

<template>
  <NCard :title="section.title">
    <template #header-extra><NText depth="3" style="font-size:12px">{{ section.id }}</NText></template>
    <NAlert v-if="section.error" type="error" show-icon style="margin-bottom:12px">
      该段加载失败：{{ section.error }}
    </NAlert>
    <NText depth="3" style="display:block;margin-bottom:12px;font-size:13px">{{ section.intro }}</NText>
    <slot />
  </NCard>
</template>
